class ClaimType {
  constructor(data) {
    data = data || {};
    this.id = data.id || null;
    this.category = data.category || null;
    this.claim_categories_id = (data.category && data.category.id) || data.claim_categories_id || null;
    this.name = data.name || null;
    this.name_l10n = data.name_l10n || [];
    this.active = data.active || null;
    this.secondary_claims_allow_receipts = data.secondary_claims_allow_receipts || null;
    this.auto_approve = data.auto_approve || null;
    this.display_order = data.display_order || null;
    this.minimum_threshold = data.minimum_threshold || null;
    this.maximum_threshold = data.maximum_threshold || null;
    this.threshold_value = data.threshold_value || null;
    this.rate = data.rate || null;
    this.budget_code = data.budget_code || null;
    this.activity_id = data.activity_id || null;
    this.collect_route_segments = data.collect_route_segments || 'f';
    this.auto_create = (data.auto_create) || null;
    this.description = (data.description) || null;
    this.use_for_forecasting = (data.use_for_forecasting) || false;
    this.position_access = (data.position_access) || null;
    this.allow_primary_claim = (data.allow_primary_claim) || null;
  }

  get isTimeBased() {
    return this.category && this.category.isTimeBased;
  }

  get isAmountBased() {
    return this.category && this.category.isAmountBased;
  }

  get isDistanceBased() {
    return this.category && this.category.isDistanceBased;
  }
}

export default ClaimType;
